"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetModify = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _Dialog = _interopRequireDefault(require("@civicplus/preamble/lib/Dialog"));

var _FormBuilder = _interopRequireDefault(require("@civicplus/preamble/lib/FormBuilder/FormBuilder"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _Loader = _interopRequireDefault(require("@civicplus/preamble/lib/Loader"));

var _PreviewAsset = _interopRequireDefault(require("./Child/PreviewAsset"));

var _react = _interopRequireWildcard(require("react"));

var _Alert = require("../Utility/Alert");

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _AssetMetadataEditor = require("./Child/AssetMetadataEditor");

var _AssetSaver = require("./AssetSaver");

var _CategoriesSelector = require("../Shared/CategoriesSelector");

var _Permissions = require("../Shared/Permissions");

var _AssetUtils = require("../Utility/AssetUtils");

var _Config = require("../Utility/Config");

var _TypeGuards = require("../Utility/TypeGuards");

var _PermissionSetSelector = require("../Shared/PermissionSetSelector");

var _Scheduler = require("../Shared/Schedule/Scheduler");

var _State = require("../Utility/State");

var _StatusDropdown = require("../Shared/StatusDropdown");

var _TagsSelector = require("../Shared/TagsSelector");

var _VersionToggle = require("../Shared/VersionToggle");

var AssetModify = function AssetModify(props) {
  var _asset$version, _asset, _item$current, _asset$permissionSet, _asset3, _asset4, _item$current3, _item$current4, _asset$tags, _item$current5, _item$current6;

  var _useState = (0, _react.useState)(props.permissionSet),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      set = _useState2[0],
      setSet = _useState2[1];

  var formRef = (0, _react.useRef)();

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      permissions = _useState4[0],
      setPermissions = _useState4[1];

  var assetsApi = (0, _react.useRef)(new _sdk.AssetsApi((0, _Config.includeFlow)(props.config)));
  var item = (0, _react.useRef)(props.trackingItem);
  var oldItem = (0, _react.useRef)(undefined);
  var statusToChangeTo = (0, _react.useRef)();

  var _useState5 = (0, _react.useState)(_State.State.Loading),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      savingState = _useState6[0],
      setSavingState = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      viewingPast = _useState8[0],
      setViewingPast = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      openScheduler = _useState10[0],
      setOpenScheduler = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      schedulerProps = _useState12[0],
      setSchedulerProps = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      isNoAccess = _useState14[0],
      setNoAccess = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      dirty = _useState16[0],
      setDirty = _useState16[1];

  var replacedAssetFile = (0, _react.useRef)(null);
  var replacedAssetFileVersion = (0, _react.useRef)(null);

  var disableForm = function disableForm() {
    return viewingPast || isNoAccess;
  };

  var asset = function asset() {
    var _oldItem$current;

    return (_oldItem$current = oldItem.current) !== null && _oldItem$current !== void 0 ? _oldItem$current : item.current;
  };

  function onItemChanged() {
    var _props$onItemChanged;

    item.current && ((_props$onItemChanged = props.onItemChanged) === null || _props$onItemChanged === void 0 ? void 0 : _props$onItemChanged.call(props, props.trackingIndex, item.current));
  }

  function onItemSaved() {
    var _props$onAssetSaved;

    item.current && ((_props$onAssetSaved = props.onAssetSaved) === null || _props$onAssetSaved === void 0 ? void 0 : _props$onAssetSaved.call(props, item.current));
  }

  function loadPermission() {
    return _loadPermission.apply(this, arguments);
  }

  function _loadPermission() {
    _loadPermission = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
      var provider, newPermissions;
      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              provider = new _Permissions.PermissionsProvider();

              if (item.current && !item.current.permissionSet && set) {
                item.current.permissionSet = set;
              }

              _context9.next = 4;
              return provider.load(props.config, item.current);

            case 4:
              newPermissions = _context9.sent;
              setPermissions(newPermissions);

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));
    return _loadPermission.apply(this, arguments);
  }

  function loadItem() {
    return _loadItem.apply(this, arguments);
  }

  function _loadItem() {
    _loadItem = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
      var success;
      return _regenerator["default"].wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              setSavingState(_State.State.Loading);
              _context11.next = 3;
              return (0, _Alert.alertOnError)("Failed to load asset", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
                return _regenerator["default"].wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        if (!item.current) {
                          _context10.next = 4;
                          break;
                        }

                        _context10.t0 = item.current;
                        _context10.next = 7;
                        break;

                      case 4:
                        _context10.next = 6;
                        return getMetaData(assetsApi.current, props.config, props.file);

                      case 6:
                        _context10.t0 = _context10.sent;

                      case 7:
                        item.current = _context10.t0;
                        onItemChanged();

                        if (item.current.categories && item.current.categories.length === 0) {
                          item.current.categories = props.categories;
                          onItemChanged();
                        }

                        if (item.current.permissionSet) {
                          setSet(item.current.permissionSet);
                        } else if (!props.isNew || set) {
                          item.current.permissionSet = set;
                          onItemChanged();
                        }

                        if (!item.current.permissionSet) {
                          _context10.next = 14;
                          break;
                        }

                        _context10.next = 14;
                        return loadPermission();

                      case 14:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10);
              })));

            case 3:
              success = _context11.sent;
              setSavingState(!success ? _State.State.Errored : _State.State.Finished);

            case 5:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
    return _loadItem.apply(this, arguments);
  }

  (0, _react.useEffect)(function () {
    loadItem(); // TODO: is this excluded on purpose?
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.file, props.config]);

  var onCreateDraft = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _Alert.runWithAlert)("Successfully created new version.", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return assetsApi.current.createDraft(props.config.appName, item.current.id);

                      case 2:
                        item.current = _context.sent;
                        onItemChanged();
                        onVersionToggled();
                        loadPermission();

                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onCreateDraft() {
      return _ref.apply(this, arguments);
    };
  }();

  var closeScheduler = (0, _react.useCallback)(function () {
    setOpenScheduler(false);
    setSchedulerProps(null);
  }, []);
  var onCancelScheduler = (0, _react.useCallback)(function () {
    closeScheduler();
    setSavingState(_State.State.Finished);
  }, [closeScheduler]);

  function submit() {
    return _submit.apply(this, arguments);
  }

  function _submit() {
    _submit = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
      var data, shouldShowScheduler, defaultMessage, scheduleprops;
      return _regenerator["default"].wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              setSavingState(_State.State.Processing);
              _context13.next = 4;
              return formRef.current.submit();

            case 4:
              data = _context13.sent;

              if (data) {
                _context13.next = 7;
                break;
              }

              return _context13.abrupt("return");

            case 7:
              Object.keys(data).forEach(function (key) {
                // TODO: Need to determine a better way to type check these keys
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                item.current[key] = data[key];
              });

              shouldShowScheduler = function shouldShowScheduler() {
                return statusToChangeTo.current != null && !props.disableSaveAndSend;
              }; // If we are not changing status, just save right away.
              // otherwise we should show the schedule dialog.


              if (shouldShowScheduler()) {
                _context13.next = 14;
                break;
              }

              _context13.next = 12;
              return onSave(data, statusToChangeTo.current);

            case 12:
              _context13.next = 18;
              break;

            case 14:
              defaultMessage = props.isNew ? "\"".concat((data === null || data === void 0 ? void 0 : data.fileName) || "Asset", "\" has been created!") : "A modification to \"".concat((data === null || data === void 0 ? void 0 : data.fileName) || "the Asset(s)", "\" has been made!");
              scheduleprops = {
                onCancel: onCancelScheduler,
                item: item.current,
                status: statusToChangeTo.current,
                onConfirm: function () {
                  var _onConfirm2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(res) {
                    return _regenerator["default"].wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            item.current = res;
                            closeScheduler();
                            _context12.next = 4;
                            return onSave(data, statusToChangeTo.current);

                          case 4:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12);
                  }));

                  function onConfirm(_x5) {
                    return _onConfirm2.apply(this, arguments);
                  }

                  return onConfirm;
                }(),
                defaultEmailSubject: defaultMessage,
                defaultTextMessage: defaultMessage
              };
              setOpenScheduler(true);
              setSchedulerProps(scheduleprops);

            case 18:
              _context13.next = 25;
              break;

            case 20:
              _context13.prev = 20;
              _context13.t0 = _context13["catch"](0);
              closeScheduler();
              setSavingState(_State.State.Finished);
              throw new Error("Failed to save, something went wrong.");

            case 25:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[0, 20]]);
    }));
    return _submit.apply(this, arguments);
  }

  var onSave = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(data, status) {
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setSavingState(_State.State.Processing);

              if (!props.onSave) {
                _context4.next = 7;
                break;
              }

              _context4.next = 4;
              return props.onSave(item.current, status);

            case 4:
              statusToChangeTo.current = undefined;
              _context4.next = 9;
              break;

            case 7:
              _context4.next = 9;
              return (0, _Alert.runWithAlert)("Successfully saved asset(s).", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                var saver;
                return _regenerator["default"].wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        onItemChanged();
                        saver = new _AssetSaver.AssetSaver(props.config, item.current, replacedAssetFile.current || props.file);
                        _context3.next = 4;
                        return saver.save(status);

                      case 4:
                        item.current = _context3.sent;
                        statusToChangeTo.current = undefined;
                        onItemSaved();

                      case 7:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              })));

            case 9:
              setSavingState(_State.State.Finished);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function onSave(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var onVersionToggled = function onVersionToggled(version) {
    setSavingState(_State.State.Loading);

    if (!oldItem.current && version) {
      oldItem.current = version;
      setViewingPast(true);
    } else {
      oldItem.current = undefined;
      setViewingPast(false);
    }

    setTimeout(function () {
      setSavingState(_State.State.Finished);
    }, 150);
  };

  (0, _react.useEffect)(function () {
    if (item.current && (item.current.permissionSet || set)) {
      loadPermission();
    } // TODO: is this excluded on purpose?
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [set]);
  var version = (_asset$version = (_asset = asset()) === null || _asset === void 0 ? void 0 : _asset.version) !== null && _asset$version !== void 0 ? _asset$version : undefined; // Show the asset id as the preview file, so we can display different versions.

  var previewFile;

  if (replacedAssetFile.current && replacedAssetFileVersion.current === version) {
    previewFile = replacedAssetFile.current;
  } else {
    var _asset2;

    previewFile = (0, _TypeGuards.isString)(props.file) ? (_asset2 = asset()) === null || _asset2 === void 0 ? void 0 : _asset2.id : props.file;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    id: props.id,
    className: "prmbl-assetModify"
  }, /*#__PURE__*/_react["default"].createElement(_PreviewAsset["default"], {
    file: previewFile,
    asset: asset(),
    config: props.config,
    height: "75%",
    width: "75%",
    version: version,
    canReplaceAsset: !props.isNew && !disableForm(),
    onAssetReplaced: function onAssetReplaced(newFile) {
      !dirty && setDirty(true);
      replacedAssetFile.current = newFile;
      replacedAssetFileVersion.current = version;
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: "1em"
    }
  }, set && permissions && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_StatusDropdown.StatusDropdown, {
    key: "status-".concat(viewingPast.toString(), "-").concat((_item$current = item.current) === null || _item$current === void 0 ? void 0 : _item$current.version),
    isNew: props.isNew,
    item: item.current,
    permissions: permissions,
    saving: savingState === _State.State.Processing,
    portal: props.portal,
    disabled: viewingPast || isNoAccess,
    saveDisabled: !dirty && !props.isMultipleUpload || disableForm(),
    onNoAccess: function onNoAccess() {
      return setNoAccess(true);
    },
    onHasAccess: function onHasAccess() {
      return setNoAccess(false);
    },
    onClearSchedule: /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(job) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return (0, _Alert.runWithAlert)("Successfully cleared schedule.", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
                  var _item$current2;

                  return _regenerator["default"].wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return assetsApi.current.clearSchedule(props.config.appName, (_item$current2 = item.current) === null || _item$current2 === void 0 ? void 0 : _item$current2.id);

                        case 2:
                          _context5.next = 4;
                          return loadItem();

                        case 4:
                          onItemSaved();

                        case 5:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                })));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }(),
    onEditSchedule: function onEditSchedule(job) {
      var scheduleprops = {
        status: job.status,
        item: item.current,
        onCancel: onCancelScheduler,
        onConfirm: function () {
          var _onConfirm = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(result) {
            return _regenerator["default"].wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return (0, _Alert.runWithAlert)("Successfully updated schedule.", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
                      var _item$current$schedul;

                      var saver;
                      return _regenerator["default"].wrap(function _callee7$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              item.current = result;
                              saver = new _AssetSaver.AssetSaver(props.config, item.current, item.current.id);
                              _context7.next = 4;
                              return saver.save((_item$current$schedul = item.current.scheduleJob) === null || _item$current$schedul === void 0 ? void 0 : _item$current$schedul.status);

                            case 4:
                              item.current = _context7.sent;
                              closeScheduler();
                              onItemChanged();
                              onItemSaved();

                            case 8:
                            case "end":
                              return _context7.stop();
                          }
                        }
                      }, _callee7);
                    })));

                  case 2:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8);
          }));

          function onConfirm(_x4) {
            return _onConfirm.apply(this, arguments);
          }

          return onConfirm;
        }()
      };
      setOpenScheduler(true);
      setSchedulerProps(scheduleprops);
    },
    onCreateDraft: onCreateDraft,
    onSave: function onSave() {
      statusToChangeTo.current = undefined;
      submit();
    },
    onStatusChange: function onStatusChange(status) {
      statusToChangeTo.current = status.status;
      submit();
    }
  }), schedulerProps && /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    id: "scheduler-modal",
    open: openScheduler,
    title: statusToChangeTo.current || "",
    onClose: onCancelScheduler
  }, /*#__PURE__*/_react["default"].createElement(_Scheduler.Scheduler, schedulerProps))), set && /*#__PURE__*/_react["default"].createElement(_VersionToggle.VersionToggle, {
    item: item.current,
    config: props.config,
    onVersionLoaded: function onVersionLoaded(data) {
      return onVersionToggled(data);
    }
  }), savingState !== _State.State.Processing && /*#__PURE__*/_react["default"].createElement(_PermissionSetSelector.PermissionSetSelector, {
    key: set === null || set === void 0 ? void 0 : set.id,
    disabled: disableForm(),
    config: props.config,
    value: (_asset$permissionSet = (_asset3 = asset()) === null || _asset3 === void 0 ? void 0 : _asset3.permissionSet) !== null && _asset$permissionSet !== void 0 ? _asset$permissionSet : set,
    onChange: function onChange(permSet) {
      var _props$onPermissionSe;

      !dirty && setDirty(true);
      item.current.permissionSet = permSet;
      (_props$onPermissionSe = props.onPermissionSetChange) === null || _props$onPermissionSe === void 0 ? void 0 : _props$onPermissionSe.call(props, permSet, props.trackingIndex);
      setSet(permSet);
    },
    isAsset: true,
    isCreating: props.isNew
  }), (savingState === _State.State.Processing || savingState === _State.State.Loading) && /*#__PURE__*/_react["default"].createElement(_Loader["default"], null), set && savingState === _State.State.Finished && item.current && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CategoriesSelector.CategoriesSelector, {
    config: props.config,
    value: (_asset4 = asset()) === null || _asset4 === void 0 ? void 0 : _asset4.categories,
    disabled: disableForm(),
    key: "category-".concat((_item$current3 = item.current) === null || _item$current3 === void 0 ? void 0 : _item$current3.version),
    onChange: function onChange(selected) {
      !dirty && setDirty(true);
      item.current.categories = selected;
      onItemChanged();
    }
  }), /*#__PURE__*/_react["default"].createElement(_FormBuilder["default"], {
    id: "hcms-asset-modify",
    hideLoadingIndicator: true,
    key: "form-".concat((_item$current4 = item.current) === null || _item$current4 === void 0 ? void 0 : _item$current4.version),
    variant: disableForm() ? "readOnly" : "editable",
    onChange: function onChange(field, value) {
      !dirty && setDirty(true); // TODO: Need to determine a better way to type check these keys
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/ban-ts-ignore
      // @ts-ignore

      item.current[field.name] = value;
      onItemChanged();
    },
    onRef: function onRef(ref) {
      return formRef.current = ref;
    },
    fields: [{
      name: "fileName",
      label: "File Name",
      properties: {
        fieldType: "String",
        editor: "Input"
      },
      isDisabled: viewingPast,
      value: asset().fileName
    }]
  }), /*#__PURE__*/_react["default"].createElement(_TagsSelector.TagsSelector, {
    value: (_asset$tags = asset().tags) !== null && _asset$tags !== void 0 ? _asset$tags : [],
    label: "Tags",
    key: "tags-".concat((_item$current5 = item.current) === null || _item$current5 === void 0 ? void 0 : _item$current5.version),
    disabled: disableForm(),
    onChange: function onChange(tags) {
      !dirty && setDirty(true);
      item.current.tags = tags;
      onItemChanged();
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: "1em"
    }
  }, /*#__PURE__*/_react["default"].createElement(_AssetMetadataEditor.AssetMetadataEditor, {
    key: "meta-".concat(viewingPast.toString(), "-").concat((_item$current6 = item.current) === null || _item$current6 === void 0 ? void 0 : _item$current6.version),
    asset: asset(),
    disabled: disableForm(),
    onChange: function onChange(data) {
      if (!(0, _isEqual["default"])(item.current.metadata, data)) {
        !dirty && setDirty(true);
        item.current.metadata = data;
        onItemChanged();
      }
    }
  })))));
};

exports.AssetModify = AssetModify;

var getMetaData = /*#__PURE__*/function () {
  var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(api, config, file) {
    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (!(0, _TypeGuards.isString)(file)) {
              _context14.next = 4;
              break;
            }

            _context14.next = 3;
            return api.getAsset(config.appName, file);

          case 3:
            return _context14.abrupt("return", _context14.sent);

          case 4:
            return _context14.abrupt("return", {
              fileName: file.name,
              _links: {},
              slug: "",
              mimeType: "",
              metadataText: "",
              metadata: {},
              fileType: file.type,
              tags: [],
              createdBy: "",
              lastModifiedBy: "",
              categories: [],
              fileExtension: (0, _AssetUtils.getFileExtension)(file.name)
            });

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function getMetaData(_x6, _x7, _x8) {
    return _ref9.apply(this, arguments);
  };
}();